import { Component } from '@angular/core';
import { OAuthService } from '@olameter/o-authentication';
import { OConfigService } from '@olameter/o-config-service';
import { LicenseManager } from 'ag-grid-enterprise';
import { UserGRPCService } from './ProxyServices/user.grpc.service';
import { ViewConfigGRPCService } from './ProxyServices/view-config.grpc.service';
import { WorkorderGRPCService } from './ProxyServices/workorder.grpc.service';
import { ONotificationService } from '@olameter/o-utilities';
import { LanguageService } from './shared/services/language.service';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  public static availableWidth;
  public static availableHeight;
  public availableLanguages: string[] = [];
  public currentLanguage = 'en';

  //TODO move to framework refer to task number 48152
  onResize(event: any) {
    setTimeout(() => {
      AppComponent.availableWidth = event.target.innerWidth;
      AppComponent.availableHeight = event.target.innerHeight;
    }, 100);
  }
  constructor(
    private _config: OConfigService,
    public authService: OAuthService,
    public userGRPCService: UserGRPCService,
    private _clientViewConf: ViewConfigGRPCService,
    private notifications: ONotificationService,
    private workorderGRPCService: WorkorderGRPCService,
    private languageService: LanguageService
  ) {}

  ngOnInit() {
    AppComponent.availableWidth = window.innerWidth;
    AppComponent.availableHeight = window.innerHeight;
    this.availableLanguages = this.languageService.getAvailableLanguages();
    this.currentLanguage = this.languageService.getCurrentLanguage();

    const aggrid = this._config.getConfig().aggrid;
    const agGridKey = aggrid?.agGridLicenseKey;
    LicenseManager.setLicenseKey(agGridKey);

    this.workorderGRPCService
      .GetApplicationBEVersion()
      .then((data: any) => {})
      .catch((reason) => {
        this.notifications.showError(
          'no connection to Work Order service' + JSON.stringify(reason)
        );
      });
    this._clientViewConf
      .GetApplicationBEVersion()
      .then((data: any) => {})
      .catch((reason) => {
        this.notifications.showError(
          'no connection to view conf service' + JSON.stringify(reason)
        );
      });
    this.userGRPCService
      .GetApplicationBEVersion()
      .then((data: any) => {})
      .catch((reason) => {
        this.notifications.showError(
          'no connection to user service' + JSON.stringify(reason)
        );
      });
  }

  onLanguageChange(languageCode: string) {
    this.languageService.setLanguage(languageCode);
    this.currentLanguage = this.languageService.getCurrentLanguage();
  }
}
